// The relay gift's card (docs/features/relay-passes.md › Gifts › From a phone): a small glass panel sized to what it
// says, near the top of the page, over whatever the app is showing — not a window. Plain DOM made here; index.html is
// not touched. `.btn` is the app's button (core/vision.css). Its controls are full 44 px targets and its text reads at
// 4.5:1 on its glass (design/tokens.json › screen).
const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]))

const STYLE = `
#relaygift { position: fixed; z-index: 60; top: calc(64px + env(safe-area-inset-top, 0px)); left: 50%; transform: translateX(-50%);
  width: max-content; max-width: min(420px, calc(100vw - 32px)); box-sizing: border-box; padding: 14px 16px 12px; border-radius: 22px;
  background: var(--c-card); -webkit-backdrop-filter: blur(24px) saturate(1.4); backdrop-filter: blur(24px) saturate(1.4);
  color: var(--c-ink); box-shadow: 0 10px 30px rgb(var(--c-shade-rgb) / calc(0.22 * var(--c-shade-k))); font: 15px/1.35 -apple-system, "SF Pro Text", system-ui, sans-serif; }
#relaygift[hidden] { display: none; }
#relaygift .t { margin: 0; font-weight: 600; }
#relaygift .n { margin: 6px 0 0; font-size: 14px; color: rgb(var(--c-ink-rgb) / 0.84); }
#relaygift select { font: inherit; font-size: 16px; font-weight: 600; color: var(--c-ink); background: rgb(var(--c-ink-rgb) / 0.16); border: 0; border-radius: 10px; padding: 0 10px; min-height: 44px; margin: 4px 0 0; max-width: 100%; }
#relaygift select option { color: #000; }
#relaygift .b { display: flex; justify-content: flex-end; gap: 8px; margin-top: 12px; }
#relaygift .b:empty { display: none; }
#relaygift .btn { appearance: none; border: 0; color: var(--c-ink); font-family: inherit; cursor: pointer; min-height: 44px; min-width: 44px; border-radius: 22px; font-size: 15px; }
#relaygift .btn.prominent { background: var(--screen-prominent); color: var(--c-on-accent); }   /* design/tokens.json › screen.prominent: white on it at 4.5:1 */
#relaygift :focus-visible { outline: 3px solid var(--focus-on-glass); outline-offset: 2px; }
`

let el = null
function make() {
  if (el) return el
  const style = document.createElement('style')
  style.textContent = STYLE
  document.head.appendChild(style)
  el = document.createElement('div')
  el.id = 'relaygift'
  el.hidden = true
  el.setAttribute('role', 'dialog')
  el.setAttribute('aria-live', 'polite')
  el.setAttribute('aria-label', 'Relay data')
  document.body.appendChild(el)
  return el
}

/// Draws `view` (offer.js's `view()`), or hides the card for null. `on.act(what)`, `on.choose(key)`.
export function drawCard(view, on) {
  const card = make()
  card.hidden = !view
  if (!view) { card.innerHTML = ''; return }
  const picker = view.choices
    ? `<select aria-label="Which Mac">${view.choices.map((c) => `<option value="${esc(c.key)}" ${c.key === view.chosen ? 'selected' : ''}>${esc(c.name)}</option>`).join('')}</select>?`
    : ''
  card.innerHTML = `<p class="t">${esc(view.title)}${picker}</p>` + (view.note ? `<p class="n">${esc(view.note)}</p>` : '') +
    `<div class="b">${view.buttons.map((b, i) => `<button type="button" class="btn small ${b.primary ? 'prominent' : 'bordered'}" data-i="${i}">${esc(b.label)}</button>`).join('')}</div>`
  for (const b of card.querySelectorAll('button')) b.onclick = () => on.act(view.buttons[+b.dataset.i].act)
  const select = card.querySelector('select')
  if (select) select.onchange = () => on.choose(select.value)
}
